export default "__VITE_ASSET___NpW8LU$__"